﻿module CommonUi

open Fable.React
open Fable.React.Props
open Messages.Signup
open Ui.Language

let pagerItem ( activeNum : int ) msg dispatch num =
    a (if activeNum = num
        then [ Class "active item" ]
        else [ Class "item"; OnClick (fun _ -> dispatch (msg num)) ]
    ) [ str (num.ToString()) ]

let noPagerItem num msg dispatch =
    a [ Class "item"; OnClick (fun _ -> dispatch (msg num)) ] [ str "..." ]

let pagerBack activeNum msg dispatch =
    div [] [
        a (if activeNum = 1
            then [ Class "disabled icon item" ]
            else [ Class "icon item"; OnClick ( fun _ -> dispatch (msg (activeNum - 1))) ]
        )
            [ i [ Class "left chevron icon" ] []
            ]
    ]

let pagerNext totalPages activeNum msg dispatch =
    div [] [
        a (if activeNum = totalPages
            then [ Class "disabled icon item" ]
            else [ Class "icon item"; OnClick (fun _ -> dispatch (msg (activeNum + 1))) ]
        )
            [ i [ Class "right chevron icon" ] []
            ]
    ]

let pageSizeOpt i =
    let iStr = i.ToString()
    option [ Value iStr ] [ str iStr ]

let pageSizes sizes =
    List.map pageSizeOpt sizes

let pageNav ( page :  Paged<'a> ) ( msg : int -> Msg  ) dispatch =
    let morePages = if page.HasMorePages then (page.CurrentPage + 1) else page.CurrentPage
    let rangeLimit = if (page.CurrentPage > 2) then (page.CurrentPage - 1) else 1
    div [ Class "ui center aligned borderless mini pagination menu" ] (
        [
            yield pagerBack page.CurrentPage msg dispatch
            if (page.CurrentPage > 2) then
                yield noPagerItem (rangeLimit - 1) msg dispatch
            yield! List.map ( pagerItem page.CurrentPage msg dispatch ) [ rangeLimit .. morePages ]
            if page.HasMorePages then
                yield noPagerItem morePages msg dispatch
            yield pagerNext morePages page.CurrentPage msg dispatch
        ]

    )


let isActiveHtml bool =
    match bool with
    | true ->
        [
            i [ Class "green circle icon" ] []
            span [] [ str (Lang.getText Keys.Active) ]
        ]
    | false ->
        [
            i [ Class "grey circle icon" ] []
            span [] [ str (Lang.getText Keys.Inactive) ]
        ]


let activeFilterHtml current =
    match current with
    | Some b ->
        isActiveHtml b
    | None ->
        [
            i [ Class "circle outline icon" ] []
            span [] [ str (Lang.getText Keys.All) ]
        ]


let activeFilterOption valueMsg dispatch current value =
    div [ Class ("item" + if current = value then " active selected" else "")
          OnClick (fun _ -> dispatch (valueMsg value)) ]
        (activeFilterHtml value)


let activeFilter current valueMsg dispatch =
    let option = activeFilterOption valueMsg dispatch
    div [ Class "ui simple selection dropdown"; Style [ MinWidth "10em" ] ] [
        i [ Class "dropdown icon"] []
        div [ Class "text" ] (activeFilterHtml current)
        div [ Class "menu" ] [
            option current (Some true)
            option current (Some false)
            option current None
        ]
    ]